import { render, staticRenderFns } from "./AssociatedContractList.vue?vue&type=template&id=145a2389"
import script from "./AssociatedContractList.vue?vue&type=script&lang=js"
export * from "./AssociatedContractList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports